/**
 * Конфигурация грида "Аудит пользователей".
 * Централизует маппинг полей API <-> DevExtreme и описание колонок.
 */
class UserAuditGridConfig {
    /** Имена полей API (ответ бэкенда user-audit). */
    static get API_FIELDS() {
        return ['dat', 'fio', 'email', 'ndog', 'entity', 'success'];
    }

    /** Маппинг dataField грида -> имя параметра для API (сортировка, фильтры). */
    static get FIELD_TO_API() {
        return {
            dat: 'dat',
            fio: 'fio',
            email: 'email',
            ndog: 'ndog',
            entity: 'entity',
            success: 'success',
        };
    }

    /** Получить имя параметра API по полю грида. */
    static getApiParam(dataField) {
        return this.FIELD_TO_API[dataField] ?? 'dat';
    }

    /** Описания колонок для DataGrid (caption, dataField, dataType, width и т.д.). */
    static getColumns() {
        return [
            {
                dataField: 'dat',
                caption: 'Дата записи',
                dataType: 'datetime',
                width: '14%',
                minWidth: 140,
                sortOrder: 'desc',
                defaultSortIndex: 0,
            },
            {
                dataField: 'fio',
                caption: 'ФИО',
                dataType: 'string',
                width: '22%',
                minWidth: 180,
            },
            {
                dataField: 'email',
                caption: 'E-mail',
                dataType: 'string',
                width: '22%',
                minWidth: 180,
            },
            {
                dataField: 'ndog',
                caption: 'Договор',
                dataType: 'string',
                width: '12%',
                minWidth: 100,
            },
            {
                dataField: 'entity',
                caption: 'Эндпоинт',
                dataType: 'string',
                width: '18%',
                minWidth: 140,
            },
            {
                dataField: 'success',
                caption: 'Успешность',
                dataType: 'boolean',
                width: '12%',
                minWidth: 100,
            },
        ];
    }
}

export default UserAuditGridConfig;
